import CorporateLayout from '../../components/CorporateLayout';
import BankInformation from './forms/BankInformation';
import ClientClassification from './forms/ClientClassification';
import ContactInformation from './forms/ContactInformation';
import CustodianDetails from './forms/CustodianDetails';
import DocumentVault from './forms/DocumentVault';
import GeneralInformation from './forms/GeneralInformation';
import InternationalTaxSelfCertification from './forms/InternationalTaxSelfCertification';
import InvestmentInformation from './forms/InvestmentInformation';
import SignatureCard from './forms/SignatureCard';
import SubmitApplication from './forms/SubmitApplication';
import CorporateFunctional from './index.function';

const CorporateForm = () => {
  const { step, onStepChange } = CorporateFunctional();

  return (
    <CorporateLayout step={step} setStep={onStepChange}>
      {
        step === 0 ?
        <GeneralInformation onDone={() => onStepChange(1)} />
        : step === 1 ?
        <ContactInformation onDone={() => onStepChange(2)} />
        : step === 2 ?
        <BankInformation onDone={() => onStepChange(3)} />
        : step === 3 ?
        <InvestmentInformation onDone={() => onStepChange(4)} />
        : step === 4 ?
        <CustodianDetails onDone={() => onStepChange(5)} />
        : step === 5 ?
        <ClientClassification onDone={() => onStepChange(6)} />
        : step === 6 ?
        <SignatureCard onDone={() => onStepChange(7)} />
        : step === 7 ?
        <InternationalTaxSelfCertification onDone={() => onStepChange(8)} />
        : step === 8 ?
        <DocumentVault onDone={() => onStepChange(9)} />
        : step === 9 ?
        <SubmitApplication setStep={onStepChange} />
        : null
      }
    </CorporateLayout>
  );
};
export default CorporateForm;
